/**
 * 10.8 — Cliente Supabase (backend do jogo: identidade + save na nuvem, base do PvP).
 *
 * A URL e a PUBLISHABLE KEY são PÚBLICAS de propósito: a publishable key é feita para ir no
 * cliente e é protegida por Row Level Security (RLS) no banco. A chave SECRETA (sb_secret_…)
 * NUNCA entra no cliente. Ver a memória do projeto (pvp-plan / vercel-web-deploy).
 *
 * Permite override por variável de ambiente (Vercel/local) sem quebrar o padrão embutido.
 */
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};

export const SUPABASE_URL = env.VITE_SUPABASE_URL || "https://esrddatbryjfbhmkxmja.supabase.co";
export const SUPABASE_KEY = env.VITE_SUPABASE_KEY || "sb_publishable_vzFDBTj07MsiVgN7oJwmFw_RnBtfnSB";

export const supabase: SupabaseClient = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true, // guarda a sessão no localStorage → mesma identidade a cada abertura
    autoRefreshToken: true,
    // 10.9IC — LOGIN SOCIAL (Google/Facebook): o provedor devolve a sessão nos parâmetros da URL
    // e é o supabase-js quem a consome. Sem isto o redirect voltava e o jogador seguia deslogado.
    // Vale também no APK, porque ele carrega a MESMA página publicada (capacitor.config server.url),
    // então a origem é https e o fluxo é idêntico ao da web.
    detectSessionInUrl: true,
  },
});
